export const types ={
    ADD:'books/AddBook'
}

export const  INITIAL_STATE = {
    books: []
};

const books = (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case types.ADD:
            return { books: action.payload.books }
        default:
            return state;
    }
}

export const Creators = {

    addBooks: books => ({
        type: types.ADD,
        payload: { books }
    }),
}

export default books;


// WEBPACK FOOTER //
// ./src/store/ducks/books.js